import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

const StackedbarChart = ({
  data,
  options,
  id = "StackedbarChart",
  canDownload = false,
}) => {
  return (
    <div
      className="flex justify-content-center align-items-center"
      style={{ position: "relative" }}
    >
      {(canDownload && (
        <Button
          rounded
          icon="pi pi-download"
          text
          size="small"
          onClick={() => {
            const canvas = document.querySelector(`#${id} canvas`);
            const image = canvas.toDataURL("image/png", 1.0);
            const link = document.createElement("a");
            link.download = `${id}.png`;
            link.href = image;
            link.click();
          }}
          style={{
            position: "absolute",
            top: "-5px",
            right: "-5px",
            zIndex: 2,
          }}
        />
      )) ||
        null}
      <Chart
        id={id}
        className="w-full flex justify-content-center align-items-center"
        style={{ height: "230px" }}
        type="bar"
        data={data}
        options={{
          maintainAspectRatio: false,
          aspectRatio: 0.8,
          with: "100%",
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
          ...options,
        }}
      />
    </div>
  );
};

export default StackedbarChart;
